import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import React from 'react'

import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import {
  MembershipFeatureRecordFieldsFragment,
  MembershipPackageRecordFieldsFragment,
} from 'GraphQL/DatoCMS/TypedDocuments'

import Button from './Button'
import Slide from './Slide'
import { Container } from './styles'

type Props = {
  packages: MembershipPackageRecordFieldsFragment[]
  features: MembershipFeatureRecordFieldsFragment[]
  onAction?: () => void
}

function TeeOffCorporateMembershipPackagesSlider({
  packages,
  features,
  onAction,
}: Props) {
  return (
    <Container>
      <Swiper
        centeredSlides
        grabCursor
        modules={[Pagination]}
        pagination={{ clickable: true }}
        slidesPerView={1}
        spaceBetween={24}
      >
        <>
          <Button />
          <Button isNext />
        </>

        {packages.map(item => (
          <SwiperSlide key={item.id}>
            <Slide features={features} item={item} onAction={onAction} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  )
}

export default TeeOffCorporateMembershipPackagesSlider
